import { GetterTree } from "vuex";

import { Area, AreaType, VacancyArea } from "throne-api";

import { RootState } from "./state";

export const getters: GetterTree<RootState, any> = {
    areaTypeList: (state: RootState): AreaType[] => {
        return state.areaList
            .map((area: Area) => area.gender)
            .filter((areaType: AreaType, index: number, self: AreaType[]) => self.indexOf(areaType) === index);
    },
    areaListFilteredByAreaType: (state: RootState) => (areaType: AreaType): Area[] => {
        return state.areaList.filter((area: Area) => area.gender === areaType);
    },
    vacancyAreaByAreaId: (state: RootState) => (areaId: number): VacancyArea | undefined => {
        return state.vacancyAreaList.filter((vacancyArea: VacancyArea) => vacancyArea.areaId === areaId).shift();
    },
    sortedFloorList: (state: RootState) => (): string[] => {
        const isNumber = (value: string): boolean => {
            const parsedValue: number = parseFloat(value);
            return isFinite(parsedValue) && !isNaN(parsedValue);
        };
        const uniqueFloorSet: Set<string> = new Set(state.areaList.map((area: Area) => area.floor));
        return Array.from(uniqueFloorSet).sort((a: string, b: string) => {
            if (isNumber(a) && isNumber(b)) {
                return a < b ? 1 : -1;
            }
            return !isNumber(a) && isNumber(b) ? 1 : -1;
        });
    },
    areaListGroupedByFloor: (state: RootState, getters: any) => (): { [floor: string]: Area[] } => {
        const areaListGroupedByFloor: { [floor: string]: Area[] } = {};
        getters["sortedFloorList"]().forEach((floor: string) => {
            areaListGroupedByFloor[floor] = state.areaList.filter((area: Area) => area.floor === floor);
            areaListGroupedByFloor[floor].sort((a: Area, b: Area) => {
                if (a.displayOrder === undefined || b.displayOrder === undefined) {
                    return 0;
                }
                return a.displayOrder < b.displayOrder ? -1 : 1;
            });
        });
        return areaListGroupedByFloor;
    },
    waitingSecondsByAreaId: (state: RootState) => (areaId: number): number => {
        const useWaitingSecondsAreaIdList: number[] = [365, 935];
        const isSugamoOrNara: boolean = useWaitingSecondsAreaIdList.includes(areaId);
        if (isSugamoOrNara) {
            // 念のため絞るが、基本的には不要の認識
            const vacancyArea: VacancyArea | undefined = state.vacancyAreaList.find(
                (vacancyArea: VacancyArea) => vacancyArea.areaId === areaId,
            );

            return vacancyArea === undefined ? 0 : vacancyArea.waitingSeconds;
        }

        return 0;
    },
    statusByAreaId: (_: RootState, getters, any) => (areaId: number): string | undefined => {
        return getters["vacancyAreaByAreaId"](areaId).status;
    },
};
